import React from 'react';
import { FIG_INK, FIG_TEXT, FIG_RED } from '../figureStyle';
import {
  VX, VW, VH, PLOT_L, PLOT_R, LEVELS, LABEL_FS, LABEL_LH,
} from './simpleTakeoffLayout';
import {
  LUMPY_CURVE, SMOOTH_CURVE, lumpyTakeoffPath,
  type LumpyCurveParams, type SmoothCurveParams,
} from './simpleTakeoffCurves';

// ─── Lumpy takeoff (tiny at-a-glance sketch) ──────────────────────────────────
// Same minimalist layout as SimpleSmoothTakeoff — linear capability scale
// (1× → 110×). The curve accelerates gently at first, then hits a sharp KINK
// where the rate of acceleration jumps — visibly accelerating before and after,
// but far steeper after — and keeps accelerating to the top (no plateau).
//
// The shape is generated from the plain-English knobs in LUMPY_CURVE
// (simpleTakeoffCurves.ts) — edit those to fine-tune, or use the live
// sliders on /figures-code. The `curve`/`smoothCurve` props exist only for
// that tuner (the pre-kink stretch is drawn from the smooth params).

export default function SimpleLumpyTakeoff({
  curve = LUMPY_CURVE,
  smoothCurve = SMOOTH_CURVE,
}: {
  curve?: LumpyCurveParams;
  smoothCurve?: SmoothCurveParams;
}) {
  return (
    <div className="mx-auto mt-4">
      <svg
        viewBox={`${VX} 0 ${VW} ${VH}`}
        className="w-full h-auto font-mono"
      >
        {LEVELS.map((lvl) => (
          <g key={lvl.lines.join(' ')}>
            <line
              x1={PLOT_L} y1={lvl.lineY} x2={PLOT_R} y2={lvl.lineY}
              stroke={FIG_INK} strokeWidth={0.75} strokeDasharray="2 3"
              opacity={lvl.lines[0] === 'Human' ? 0.55 : 0.32}
            />
            <text
              x={PLOT_L - 4}
              y={(lvl.labelY ?? lvl.lineY) + 2 - ((lvl.lines.length - 1) * LABEL_LH) / 2}
              textAnchor="end" fontSize={LABEL_FS} fill={FIG_TEXT}
            >
              {lvl.lines.map((ln, i) => (
                <tspan key={ln} x={PLOT_L - 4} dy={i === 0 ? 0 : LABEL_LH}>
                  {ln}
                </tspan>
              ))}
            </text>
          </g>
        ))}

        <path
          d={lumpyTakeoffPath(curve, smoothCurve)} fill="none" stroke={FIG_RED}
          strokeWidth={2.75} strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
